import CompanyNews from './CompanyNews';

export default CompanyNews;
